var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 512 511",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#607d8b",
    d: "M362.668 512.484H64c-35.285 0-64-28.714-64-64V149.816c0-35.285 28.715-64 64-64h170.668c11.797 0 21.332 9.559 21.332 21.336 0 11.774-9.535 21.332-21.332 21.332H64c-11.777 0-21.332 9.578-21.332 21.332v298.668c0 11.754 9.555 21.332 21.332 21.332h298.668c11.773 0 21.332-9.578 21.332-21.332V277.816c0-11.773 9.535-21.332 21.332-21.332s21.336 9.559 21.336 21.332v170.668c0 35.286-28.715 64-64 64zm0 0",
    opacity: 1,
    "data-original": "#607d8b",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#42a5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.813 68.262 200.02 237.05a10.793 10.793 0 0 0-2.922 5.437l-15.082 75.438c-.703 3.496.406 7.101 2.922 9.64a10.673 10.673 0 0 0 7.554 3.114c.68 0 1.387-.063 2.09-.211l75.414-15.082c2.09-.43 3.988-1.43 5.461-2.926l168.79-168.79zM496.383 16.102c-20.797-20.801-54.633-20.801-75.414 0l-29.524 29.523 75.414 75.414 29.524-29.527C506.453 81.465 512 68.066 512 53.816s-5.547-27.648-15.617-37.714zm0 0",
    fill: "#42a5f5",
    opacity: 1,
    "data-original": "#42a5f5",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.90e3c9cadc7a2963885c1f982ce7b946.svg";
export { ForwardRef as ReactComponent };